export const MuiDateTimePicker = () => ({
    defaultProps: {
        format: "MM/DD/YYYY, hh:mm A",
        skipDisabled: true,
    },
});
